
<div class="padding-20 ui-g" id="c3_searchStores_Modal">



   <!-- Bottoni Annulla e Aggiungi -->

   <div class="ui-dialog-footer fixed-buttons buttonsContainer">
     <button data-testid="annulla_stores" pButton (click)="onClickAnnullaStores()" type="button" class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
     <button data-testid="aggiungi_stores" pButton *ngIf="!readOnly" type="button" (click)="onClickAggiungiStores()" type="button" class="k-generic-btn footer-btn" label="{{'common.save' | translate}}"></button>
     <div class="clear_fix"></div>
   </div>


  <br />
  <br />
  <br />

  <div class=" ui-g-12 campaignStoresTop">
    <app-campaign-3-kontable
    *ngIf="storesList && show.table"
    id="storesListTable"
    [columns] = "[
    { field: 'id', title: 'campaign.id' },
    { field: 'host_code', title: 'campaign.code' },
    { field: 'name', title: 'campaign.name' },
    { field: 'salesNetworkName', title: 'campaign.store' , filterTemplate: insegnaFilter, filterType: customFilter },
    { field: 'salesNetworkName', title: 'campaign.group' , filterTemplate: gruppoFilter, filterType: customFilter },
    { field: 'salesNetworkName', title: 'campaign.areas' , filterTemplate: areaFilter, filterType: customFilter },
    { field: 'address_1', title: 'store.address' }
  ]"

    [paginationType]="paginationType"
    [showInfoButton]="false"
    [showGlobalFilter]="false"
    [showDetailsButton]="false"
    [showRecoverButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showEditButton]="false"
    [showDeleteButton]="false"
    [allowSelectRow]="false"
    [source]="storesList"
    [showSelectButton]="!readOnly"
    (onSelected)="onStoresSelected($event)"
    #storesListTable>


    <ng-template #areaFilter data-testid="areaFilter" let-col>
      <p-multiSelect [options]="areeList" (onChange)="onChangeFilters()" [(ngModel)]="filterModel.area" placeholder="Scegli aree" optionLabel="descrizione" display="chip"></p-multiSelect>
    </ng-template>

    <ng-template #insegnaFilter data-testid="insegnaFilter" let-col>
      <p-multiSelect [options]="insegneList" (onChange)="onChangeFilters()" [(ngModel)]="filterModel.insegna" placeholder="Scegli insegne" optionLabel="insegna" display="chip"></p-multiSelect>
    </ng-template>

    <ng-template #gruppoFilter data-testid="gruppoFilter" let-col>
      <p-multiSelect #gruppoFilterMultiselect data-testid="gruppoFilterMultiselect" [options]="groupList" (onChange)="onChangeFilters()" [(ngModel)]="filterModel.gruppo" placeholder="Scegli gruppi" optionLabel="name" display="chip"></p-multiSelect>
    </ng-template>


  </app-campaign-3-kontable>
  </div>
  <br />
  <br />
  <div class="campaignStoresBottom ui-g-12 ui-g">
   <div class="ui-g-8 selectionContainer">
    <div class="ui-g-4" *ngFor="let store of listStoresSelected; let i=index;">
      <div class="singleStoreSelected">
        <span  *ngIf="!readOnly" class="fa fa-trash pointer" (click)="onClickRemoveSelected(i)"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{store.name}}</span>
      </div>
    </div>
   </div>
   <div class="ui-g-4" *ngIf="!readOnly">

    <app-form-fields #groupName data-testid="groupName" [(fieldModel)]="fieldModel.groupName" [name]="'name'" [label]="'Nome gruppo'" [type]="'string'"
    [required]="false"
    [maxLength]="100"></app-form-fields>
    <br />
    <div class="btnSaveGroup" [ngClass]="{'enabled': listStoresSelected && listStoresSelected.length>0 && fieldModel.groupName!=null && fieldModel.groupName!='', 'disabled': !listStoresSelected || listStoresSelected.length==0 || fieldModel.groupName==null || fieldModel.groupName=='' }" (click)="onClickSaveGroup()">Salva negozi selezionati come gruppo</div>
   </div>
  </div>


</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-stores/campaign-3-search-stores.component.html